import React from 'react';

export default function SessionList({ sessions }) {
  if (!sessions.length) return <p>No sessions yet.</p>;
  return (
    <ul>
      {sessions.map(s => (
        <li key={s.id} style={{ marginBottom: '16px', padding: '8px', borderBottom: '1px solid #eee' }}>
            <b>Goal:</b> {s.goal_name || 'N/A'}<br />
            <b>Started:</b> {s.start_time ? new Date(s.start_time).toLocaleString() : 'N/A'}<br />
            <b>Ended:</b> {s.end_time ? new Date(s.end_time).toLocaleString() : 'N/A'}<br />
            <b>Duration:</b> {Math.round(s.actual_duration_seconds / 60)} minutes<br />
            <b>Status:</b> {s.status.charAt(0).toUpperCase() + s.status.slice(1)}<br />
            {s.notes && <div><b>Notes:</b> {s.notes}</div>}
        </li>
      ))}
    </ul>
  );
}
